module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-30000-3c279de5.png";